import { Params } from '@angular/router';
import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { IFilter } from '../interfaces/filter.interface';
import { FilterTypesEnum, ReportParamsEnum } from '../reports.enum';
import { DateRange } from './date-range.model';

export const FILTER_NON_DATE_SCHEMA = Object.freeze({
  TYPE: FilterTypesEnum.non_date,
  VALID_TAX_YEARS: List<number>([]),
  VALID_CAL_YEARS: List<number>([]),
  CURRENT_YEAR: DateRange,
  CURRENT_QUARTER: DateRange,
  CURRENT_MONTH: DateRange,
  SELECTED_FILTER: null, // DateRange
});
export const RECORD = generateSchema(FILTER_NON_DATE_SCHEMA);
export const KEYS: any = generateKeys(FILTER_NON_DATE_SCHEMA);

export class FilterNonDate extends Record(RECORD) implements IFilter {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CURRENT_YEAR,
        value: new DateRange(this.currentYear),
      },
      {
        key: KEYS.CURRENT_QUARTER,
        value: new DateRange(this.currentQuarter),
      },
      {
        key: KEYS.CURRENT_MONTH,
        value: new DateRange(this.currentMonth),
      },
      {
        key: KEYS.SELECTED_FILTER,
        value: this.get(KEYS.SELECTED_FILTER)
          ? new DateRange(this.selectedFilter)
          : null,
      },
    ]);

    return selfModel as FilterNonDate;
  }

  get type(): FilterTypesEnum {
    return this.get(KEYS.TYPE);
  }

  get validTaxYears(): List<number> {
    return this.get(KEYS.VALID_TAX_YEARS);
  }

  get validCalYears(): List<number> {
    return this.get(KEYS.VALID_CAL_YEARS);
  }

  get currentYear(): DateRange {
    return this.get(KEYS.CURRENT_YEAR);
  }

  get currentQuarter(): DateRange {
    return this.get(KEYS.CURRENT_QUARTER);
  }

  get currentMonth(): DateRange {
    return this.get(KEYS.CURRENT_MONTH);
  }

  get selectedFilter(): DateRange {
    return this.get(KEYS.SELECTED_FILTER);
  }

  get queryParams(): Params {
    const selectedFilter: DateRange = this.selectedFilter;

    return selectedFilter
      ? selectedFilter.queryParams
      : {
          [ReportParamsEnum.date_increment]: 'all_time',
        };
  }
}
